import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import { handleError } from "../../../modules/errorLogger";
import { checkHttpStatus, get } from "../../../modules/httpFunctions";

import "./index.css";

const prodEnvironments = ["prod", "iprd"];
const defaultClass = "background-overlay";
const id = "environment-div";

const useStyles = createUseStyles({
  environment: (props) => ({
    height: props.height,
  }),
});

const EnvironmentBackground = () => {
  const [environmentClass, setEnvironmentClass] = useState(defaultClass);
  const [production, setProduction] = useState(true);
  useEffect(() => {
    get("health", false)
      .then((r) => {
        if (checkHttpStatus(r)) {
          const { data } = r;
          const env = (data && data.environment) || "prod";
          setEnvironmentClass(
            `${defaultClass} background-${
              env === "test"
                ? "test"
                : env === "edge"
                ? "edge"
                : env === "sdpt"
                ? "sandpit"
                : ""
            }`
          );
          setProduction(
            data && data.environment
              ? prodEnvironments.includes(data.environment)
              : true
          );
        } else {
          setEnvironmentClass(defaultClass);
          setProduction(true);
        }
      })
      .catch((err) => {
        setEnvironmentClass(defaultClass);
        setProduction(true);
        handleError(err);
      });
  }, []);

  const [height, setHeight] = useState();
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.length > 0 &&
        setHeight(`${entries[0].contentRect.height + 175}px`);
    });
    resizeObserver.observe(
      document.getElementsByClassName("app-content").item(0)
    );
    return () => resizeObserver.disconnect();
  }, []);

  const classes = useStyles({ height });

  return production ? (
    <></>
  ) : (
    <div id={id} className={`${environmentClass} ${classes.environment}`}></div>
  );
};

export default EnvironmentBackground;
